import React from 'react';
import { UserReward } from '../../Types/UserReward';
import RewardCard, { RewardCardRarity } from '../RewardCard';

interface VideoGenerationRewardProps {
  reward: UserReward;
}

const VideoGenerationReward: React.FC<VideoGenerationRewardProps> = ({
  reward,
}) => {
  const videoContent = (
    <div className="flex flex-col items-center justify-center">
      <div className="w-16 h-16 flex items-center justify-center mb-1">
        <img
          src={require('../../assets/camera.png')}
          alt=""
          className="w-12 h-12 object-contain"
        />
      </div>
    </div>
  );

  return (
    <RewardCard
      reward={reward}
      title="Video Token"
      description="Create a video for your book when it's done and published"
      rarity={RewardCardRarity.Rare}
      content={videoContent}
      type="Video"
    />
  );
};

export default VideoGenerationReward;
